// extracted by mini-css-extract-plugin
export default {"rightSide":"RightSide_rightSide__y3rdV"};